import { Injectable } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { AuthDomainService } from '../domains/auth.service';
import { SocketService } from './socket.service';
import { User } from '../models/user';
import { Router, ActivatedRoute } from '@angular/router';

const USER_UPDATE = 'USER_UPDATE';

/**
 * Сервис состояния авторизации пользователя.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  authProcess = false;
  input: any;
  user: User | null = null;
  updateEvent: EventEmitter<any> = new EventEmitter();
  refresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private authDomainService: AuthDomainService,
    private socket: SocketService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.authProcess = false;
    // Проверка авторизации при инициализации сервиса
    this.authDomainService.checkAuth()
      .pipe(catchError(() => {
        return [];
      }))
      .subscribe((user) => {
        this.setUser(user);
      });

    // Подписка на обновление пользователя через сокет
    this.socket.addListener(USER_UPDATE, (datauser: User | null) => {
      this.updateUser(datauser);
    });
  }

  private updateUser(datauser: User | null): void {
    if (datauser && this.user && datauser.cUid === this.user.cUid) {
      this.setUser(datauser);
      this.updateEvent.emit(datauser);
    }
  }

  // Устанавливает текущего пользователя
  public setUser(user: User | null): void {
    if (user) {
      this.user = new User(user, true);
    } else {
      this.user = null;
    }
  }

  // Логаут из профиля пользователя
  exitNow() {
    return this.authDomainService.logout().pipe(
      map(() => {
        this.setUser(null);
        localStorage.clear();
        this.router.navigate(['/'], { relativeTo: this.route });
        this.refresh.emit();
      })
    );
  }
}

